import React, { useState } from "react";
import { observer } from "mobx-react";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import { PayoutController, PayrollController } from "../../controllers";
import { object, string } from "yup";
import { IgnorePayout } from "../../pages";

const IgnorePayoutContainer = ({ closeModal, selectedRows }) => {
  const [loading, setLoading] = useState(false);

  const selectedIds = selectedRows.map(
    (selectedRow) => selectedRow.original._id
  );

  const validationSchema = () => {
    return object({
      status: string().required("Please select status"),
      comment: string().required("Please enter comment"),
    });
  };
  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      ids: selectedIds,
      status: values.status,
      comment: values.comment,
    };
    const { status, errorMessage } =
      await PayoutController.ignorePayout(payload);
    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    setLoading(false);
    MimaToastUtil.error({
      message: errorMessage,
    });
    closeModal();
  };

  return (
    <IgnorePayout
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
    />
  );
};

export default observer(IgnorePayoutContainer);
